import React from "react";
import { HomeLayout1, HomeLayout2 } from "../components/HomeLayouts";
import mukwae from "../images/mukwae.png";
import julia from "../images/julia.png";
import mwape from "../images/mwape.png";
import mwenya from "../images/mwenya.png";
import loongo from "../images/loongo.png";
import lueji from "../images/lueji.png";
import { Link } from "react-router-dom";

const Main = () => {
  return (
    <div>
      <div className="featured py-24 px-60 md:hidden">
        <Link to="/women/mukwae">
          <HomeLayout1
            header="MUKWAE"
            content="Known as The Great Mukwae of Nalolo Western Province she governed
              a province of the Barotse Kingdom of Nalolo and maintained a
              dignity second only to the King."
            image={mukwae}
          />
        </Link>
        <Link to="/women/julia-chikamoneka">
          <HomeLayout2
            header="JULIA CHIKAMONEKA"
            content="Inspired by the lives of historical women between the 17th and
              19th centuries, we create a portal into the communities they led,
              the items they held dearly, and the spaces they impacted. Our
              stories depict women from all the 10 provinces of Zambia in
              celebration and honour."
            image={julia}
          />
        </Link>
        <Link to="/women/mwape">
          <HomeLayout1
            header="MWAPE"
            content="More known as a fearless warrior, Mwape was a ruler of a kingdom
              which comprised the middle Luangwa and Chuambira valley and also
              further east, she fought against the Chikunda slave traders."
            image={mwape}
          />
        </Link>
        <Link to="/women/mwenya">
          <HomeLayout2
            header="MWENYA"
            content="Mwenya Mukulu was the leader of the Lungu, Azamba, and Azao
              people. As a queen, she ended up being the founder of the Lungu
              nation which present day Mbala/Mpulungu areas in Zambia."
            image={mwenya}
          />
        </Link>
        <Link to="/women/loongo">
          <HomeLayout1
            header="LOONGO"
            content="The warrior queen, who ruled the Sala people of the Mumbwa area.
              she organized an army of women and fought against the Makololo
              which made them respect her for her unusual courage."
            image={loongo}
          />
        </Link>
        <Link to="/women/lueji-wa-nkonde">
          <HomeLayout2
            header="LUEJI WA NKONDE"
            content="Lueji was the daughter of Mwata Iyala Mwaku, a descendant of Queen Kenga Naweji. Mwata Iyala Mwaku appointed her as his successor, or Nswana Mu Luunda and gave her the Lukano bracelet."
            image={lueji}
          />
        </Link>
      </div>
      <div className="featured-md py-20 px-8 space-y-20 md-min:hidden">
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/mukwae">
              <div className="border-2 border-secondary p-0">
                <img src={mukwae} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">MUKWAE</h1>
            <p className="text-sm">
              Known as The Great Mukwae of Nalolo Western Province she governed
              a province of the Barotse Kingdom of Nalolo and maintained a
              dignity second only to the King.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/julia-chikamoneka">
              <div className="border-2 border-secondary p-0">
                <img src={julia} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">JULIA CHIKAMONEKA</h1>
            <p className="text-sm">
              Known as The Great Mukwae of Nalolo Western Province she governed
              a province of the Barotse Kingdom of Nalolo and maintained a
              dignity second only to the King.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/mwape">
              <div className="border-2 border-secondary p-0">
                <img src={mwape} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">MWAPE</h1>
            <p className="text-sm">
              More known as a fearless warrior, Mwape was a ruler of a kingdom
              which comprised the middle Luangwa and Chuambira valley and also
              further east, she fought against the Chikunda slave traders.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/mwenya">
              <div className="border-2 border-secondary p-0">
                <img src={mwenya} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">MWENYA</h1>
            <p className="text-sm">
              Mwenya Mukulu was the leader of the Lungu, Azamba, and Azao
              people. As a queen, she ended up being the founder of the Lungu
              nation which present day Mbala/Mpulungu areas in Zambia.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/lueji-wa-nkonde">
              <div className="border-2 border-secondary p-3">
                <img src={lueji} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">LUEJI WA NKONDE</h1>
            <p className="text-sm">
              Lueji was the daughter of Mwata Iyala Mwaku, a descendant of Queen
              Kenga Naweji. Mwata Iyala Mwaku appointed her as his successor, or
              Nswana Mu Luunda and gave her the Lukano bracelet.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-10">
          <div>
            <Link to="/women/loongo">
              <div className="border-2 border-secondary p-0">
                <img src={loongo} alt="" className="h-full" />
              </div>
            </Link>
          </div>
          <div className="text-center space-y-4">
            <h1 className="text-2xl">LOONGO</h1>
            <p className="text-sm">
              The warrior queen, who ruled the Sala people of the Mumbwa area.
              she organized an army of women and fought against the Makololo
              which made them respect her for her unusual courage.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
